import React from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Container } from './styles';

export default function DialogSp(props) {
  const { visible, setVisible, title, body, handleClose, contentStyle } = props;

  const footer = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {
          if (handleClose) {
            handleClose(1);
          }
        }}
        className="p-button-success"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        onClick={() => {
          setVisible(false);
          if (handleClose) {
            handleClose(2);
          }
        }}
        className="p-button-danger"
      />
    </div>
  );
  return (
    <Container>
      <Dialog
        closable={false}
        footer={footer}
        header={title || 'Confirmação'}
        visible={visible}
        contentStyle={contentStyle}
        style={{ minWidth: '350px', maxWidth: '400px', width: '95%', minHeight: 600 }}
        modal
        onHide={() => {
          setVisible(false);
          if (handleClose) {
            handleClose(0);
          }
        }}
      >
        {body}
      </Dialog>
    </Container>
  );
}
